import React from 'react'
import { Col, Container, Row } from 'reactstrap';
import ExpensesSection from './components/ExpensesSection';

const Expenses = () => (
    <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 style={{ marginBottom: 30 }}>Gastos</h3>
      </Col>
    </Row>
    <Row>
        <ExpensesSection />
    </Row>
  </Container>
)

export default Expenses